import React, { Fragment } from "react"

import ModernButton from "shared/components/Button/ModernButton"
import LegalText from "./components/LegalText"
import Banner from "./components/BannerClubAlgar"
import TypographLink from "shared/components/TypographLink"

import { downloadFile } from "services/utils/downloadAudio"

import iconTicket from "assets/svg/icon-ticket.svg"

import styles from "./styles.css"
import Benefits from "./components/Benefits"

const AlgarForever = () => {
  const actionComponent = ({ link, isExternal, onClick }) => {
    const handleClick = (e) => {
      if (!link || link === "#") {
        onClick && onClick(e)
        return
      }

      if (isExternal) {
        downloadFile(link, {
          target: "_blank"
        })
        return
      }

      window.location.href = link
    }

    return (
      <ModernButton
        shape="outline"
        size="regular"
        buttonColor="deep_sea_green"
        text="Saber mais"
        textColor="deep_sea_green"
        textSize="small"
        withBorderRadius
        onClick={handleClick}
        classNames={styles.buttonClasses}
      />
    )
  }

  const profitCards = [
    {
      title: "Parceiros Algar",
      desc: "Você com desconto nos melhores lugares e experiências.",
      isLowOpacity: true,
      inconActionComponent: actionComponent({
        link: "https://algar.clubeparcerias.com.br/",
        isExternal: true
      }),
      icon: iconTicket
    }
  ]

  return (
    <Fragment>
      <Banner />
      <TypographLink to="/" size="small">
        {`< Voltar`}
      </TypographLink>
      <Benefits profitCards={profitCards} />
      <LegalText />
    </Fragment>
  )
}

export default AlgarForever



// WEBPACK FOOTER //
// ./src/scenes/AlgarForever/index.js